module.exports = __webpack_public_path__ + "static/img/banner.41049cea.png";